// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3rdPc","header":"Messages_header__3Bczx"};